module.exports = __webpack_public_path__ + "img/0S6A9419.57948256.jpg";